<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">
        <h1>Voucher Codes</h1>
        <hr>
      </div>
    </div>

    <CreateNewVoucherCodes
      @voucherCodesCreated="() => $refs.currentVoucherCodes.loadData()"
    />

    <CurrentVoucherCodes
      ref="currentVoucherCodes"
    />
  </div>
</template>

<script>
  import CreateNewVoucherCodes from './voucher-codes/CreateNewVoucherCodes'
  import CurrentVoucherCodes from './voucher-codes/CurrentVoucherCodes'

  export default {
    components: {
      CreateNewVoucherCodes,
      CurrentVoucherCodes,
    },
  }
</script>
